import { Box, Paper, TextField } from "@mui/material";
import { useAppDispatch, useAppSelector } from "app/hooks";
import {
  clearHighlightMarkerLocation,
  selectLotLocationsFiltered,
  setHighlightedMarkerLocation
} from "features/lotLocations/lotLocationsSlice";
import { clearClickedMarker, selectClickedMarker } from "features/lotOffer/lotOfferSlice";
import { getFirstImageThumbnail } from "hooks/useFirstImage";
import "leaflet/dist/leaflet.css";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../Lossuche.module.css";
import HolzpolterInfo from "./HolzpolterInfo";
import { Virtuoso } from 'react-virtuoso';
import { debounceFunction } from "functions/debounce";

export default function LosSuche() {
  const lotLocationOffers = useAppSelector(selectLotLocationsFiltered);
  const clickMarker = useAppSelector(selectClickedMarker);
  const selectedIndex = clickMarker ? lotLocationOffers.findIndex(el => el.id === clickMarker.id) : -1;
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  // Use Object for debouncing both the higlight and clear function
  // This is a workaround to avoid using a ref, which is not recommended in this case
  // because it would not be cleared when the component unmounts
  // and would cause memory leaks
  // const highlightTimerObject = useRef({ timer: undefined });
  var highlightTimerObject = { timer: undefined };
  const highlightMarker = (data: any) => {
    dispatch(setHighlightedMarkerLocation(data[0]));
    // console.log(data[0])
  };

  const clearHighlightMarker = () => {
    dispatch(clearClickedMarker());
    dispatch(clearHighlightMarkerLocation());
  };

  function handleContainerClick(lotId: string) {
    navigate(`/lossuche/${lotId}`);
  }
  const scrollToRef = useRef<HTMLElement | null>(null);
  const virtuosoRef = useRef<any>(null);

  // console.log(lotLocationOffers)

  const inputElement = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputElement.current) {
      inputElement.current.focus();
    }
  }, []);
  useEffect(() => {
    
    if (selectedIndex >= 0 && virtuosoRef.current) {
      virtuosoRef.current.scrollToIndex({
        index: selectedIndex,
        align: "start"
      });
    }
  }, [selectedIndex]);


  useEffect(() => {
    if (inputElement.current) {
      inputElement.current.focus();
    }
  }, []);

  return (
    <Box
      sx={{
        alignSelf: "start",
        maxHeight: "100%",
        height: "100vh",
        overflow: "hidden",
        width: "50%",
        display: { xs: "none", md: "block" },
      }}
    >
      <Virtuoso
        style={{
          height: '100%',
          overflowY: "auto",
        }}
        ref={virtuosoRef}
        totalCount={lotLocationOffers.length}
        itemContent={index => {
          const lotLocationOffer = lotLocationOffers[index];
          const isCentered = selectedIndex === index;
          const lotImage = getFirstImageThumbnail(lotLocationOffer.images);
          return (
            <Box
              key={index}
              ref={isCentered ? scrollToRef : null}
              sx={{
                mt: "10px",
                padding: "15px 15px",
                cursor: "pointer",
              }}
              onMouseEnter={() => {
                debounceFunction(highlightMarker, 250, highlightTimerObject)(lotLocationOffer.wood_piles);
              }}
              onMouseLeave={() => {
                debounceFunction(clearHighlightMarker, 250, highlightTimerObject)();
              }}
              onClick={() => {
                handleContainerClick(lotLocationOffer.id);
                // console.log('info')
              }}
            >
              {(isCentered && selectedIndex === index) && (
                <Box sx={{ height: 0, width: 0, overflow: "hidden" }}>
                  <TextField autoFocus={true} className={styles.display} />
                </Box>
              )}

              <Paper
                className={styles.lossucheContainer}
                sx={{
                  overflow: "hidden",
                  borderColor: "#072C25",
                  borderStyle: "solid",
                  borderWidth: isCentered ? 3 : 0,
                }}
              >
                <Box component="div" className={styles.lossucheImage}>
                  <Box
                    component="img"
                    sx={{
                      aspectRatio: "4/3",
                      objectFit: "cover",
                      width: "100%",
                      overflow: "hidden",
                      transition: "transform 0.4s",
                      transformOrigin: "50% 50%",
                      "&:hover": {
                        transform: "scale(1.05)",
                      },
                      flexShrink: 0,
                      minWidth: "120px",
                    }}
                    alt="image"
                    loading="lazy"
                    src={lotImage}
                  />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flex: "2 1 70%",
                    width: "auto",
                    borderRadius: "0px 30px 30px 0px !important",
                  }}
                >
                  <HolzpolterInfo
                    lotImage={lotImage}
                    lotInformation={lotLocationOffer}
                    loginNeeded={lotLocationOffer.login_and_validation_required}
                  />
                </Box>
              </Paper>
            </Box>
          );
        }}
      />
    </Box>
  );
}